export default "Taux réduits et exonérations de l'accise sur l'électricité (ex-CSPE/TICFE) : éligibilité, démarches et remboursement rétroactif du trop-versé. Vérification gratuite pour votre activité.";
